import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item";

export const FeedNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });
  return (
    <NavItem
      icon="activity-feed"
      {...props}
      isActiveTest={(path) => path.match(/^\/feed/)}
      name={t("activityFeed")}
      id="feed"
      href="/feed/my_feed"
    />
  );
};
